import { S as b } from "./Base-pdJ5fkYW.js";
import { n as l } from "./property-BWlAHqg_.js";
let r = !0;
try {
  document.body.querySelector(":focus-visible");
} catch {
  r = !1, import("./focus-visible-DSblPDo8.js").then((t) => t.f);
}
const m = (a) => {
  var t, s;
  const e = Symbol("endPolyfillCoordination");
  class o extends (s = a, t = e, s) {
    constructor() {
      super(...arguments), this[t] = null;
    }
    connectedCallback() {
      super.connectedCallback && super.connectedCallback(), r || requestAnimationFrame(() => {
        this[e] == null && (this[e] = ((i) => {
          if (i.shadowRoot == null || i.hasAttribute("data-js-focus-visible")) return () => {
          };
          if (!self.applyFocusVisiblePolyfill) {
            const h = () => {
              self.applyFocusVisiblePolyfill && i.shadowRoot && self.applyFocusVisiblePolyfill(i.shadowRoot), i.manageAutoFocus && i.manageAutoFocus();
            };
            return self.addEventListener("focus-visible-polyfill-ready", h, { once: !0 }), () => {
              self.removeEventListener("focus-visible-polyfill-ready", h);
            };
          }
          return self.applyFocusVisiblePolyfill(i.shadowRoot), i.manageAutoFocus && i.manageAutoFocus(), () => {
          };
        })(this));
      });
    }
    disconnectedCallback() {
      super.disconnectedCallback && super.disconnectedCallback(), r || requestAnimationFrame(() => {
        this[e] != null && (this[e](), this[e] = null);
      });
    }
  }
  return o;
};
var p = Object.defineProperty, f = Object.getOwnPropertyDescriptor, u = (a, t, s, e) => {
  for (var o, n = e > 1 ? void 0 : e ? f(t, s) : t, i = a.length - 1; i >= 0; i--) (o = a[i]) && (n = (e ? o(t, s, n) : o(n)) || n);
  return e && n && p(t, s, n), n;
};
function c() {
  return new Promise((a) => requestAnimationFrame(() => a()));
}
class d extends m(b) {
  constructor() {
    super(...arguments), this.disabled = !1, this.autofocus = !1, this._tabIndex = 0, this.manipulatingTabindex = !1, this.autofocusReady = Promise.resolve();
  }
  get tabIndex() {
    if (this.focusElement === this) {
      const s = this.hasAttribute("tabindex") ? Number(this.getAttribute("tabindex")) : NaN;
      return isNaN(s) ? -1 : s;
    }
    const t = parseFloat(this.hasAttribute("tabindex") && this.getAttribute("tabindex") || "0");
    return this.disabled || t < 0 ? -1 : this.focusElement ? this._tabIndex : t;
  }
  set tabIndex(t) {
    var s;
    if (this.manipulatingTabindex) this.manipulatingTabindex = !1;
    else if (this.focusElement !== this) if (t === -1 ? this.addEventListener("pointerdown", this.onPointerdownManagementOfTabIndex) : (this.manipulatingTabindex = !0, this.removeEventListener("pointerdown", this.onPointerdownManagementOfTabIndex)), t === -1 || this.disabled) {
      if (this.manipulatingTabindex = !0, this.setAttribute("tabindex", "-1"), this.removeAttribute("focusable"), this.selfManageFocusElement) return;
      t !== -1 ? (this._tabIndex = t, this.manageFocusElementTabindex(t)) : (s = this.focusElement) == null || s.removeAttribute("tabindex");
    } else this.setAttribute("focusable", ""), this.hasAttribute("tabindex") ? this.removeAttribute("tabindex") : this.manipulatingTabindex = !1, this._tabIndex = t, this.manageFocusElementTabindex(t);
    else if (this.disabled) this._tabIndex = t;
    else if (t !== this._tabIndex) {
      this._tabIndex = t;
      const e = "" + t;
      this.manipulatingTabindex = !0, this.setAttribute("tabindex", e);
    }
  }
  onPointerdownManagementOfTabIndex() {
    this.tabIndex === -1 && setTimeout(() => {
      this.tabIndex = 0, this.focus({ preventScroll: !0 }), this.tabIndex = -1;
    });
  }
  async manageFocusElementTabindex(t) {
    this.focusElement || await this.updateComplete, t === null ? this.focusElement.removeAttribute("tabindex") : this.focusElement !== this && (this.focusElement.tabIndex = t);
  }
  get focusElement() {
    throw new Error("Must implement focusElement getter!");
  }
  get selfManageFocusElement() {
    return !1;
  }
  focus(t) {
    this.disabled || !this.focusElement || (this.focusElement !== this ? this.focusElement.focus(t) : HTMLElement.prototype.focus.apply(this, [t]));
  }
  blur() {
    const t = this.focusElement || this;
    t !== this ? t.blur() : HTMLElement.prototype.blur.apply(this);
  }
  click() {
    if (this.disabled) return;
    const t = this.focusElement || this;
    t !== this ? t.click() : HTMLElement.prototype.click.apply(this);
  }
  manageAutoFocus() {
    this.autofocus && (this.dispatchEvent(new KeyboardEvent("keydown", { code: "Tab" })), this.focusElement.focus());
  }
  firstUpdated(t) {
    super.firstUpdated(t), (!this.hasAttribute("tabindex") || this.getAttribute("tabindex") !== "-1") && this.setAttribute("focusable", "");
  }
  update(t) {
    t.has("disabled") && this.handleDisabledChanged(this.disabled, t.get("disabled")), super.update(t);
  }
  updated(t) {
    super.updated(t), t.has("disabled") && this.disabled && this.blur();
  }
  async handleDisabledChanged(t, s) {
    const e = () => this.focusElement !== this && this.focusElement.disabled !== void 0;
    t ? (this.manipulatingTabindex = !0, this.setAttribute("tabindex", "-1"), await this.updateComplete, e() ? this.focusElement.disabled = !0 : this.setAttribute("aria-disabled", "true")) : s && (this.manipulatingTabindex = !0, this.focusElement === this ? this.setAttribute("tabindex", "" + this._tabIndex) : this.removeAttribute("tabindex"), await this.updateComplete, e() ? this.focusElement.disabled = !1 : this.removeAttribute("aria-disabled"));
  }
  async getUpdateComplete() {
    const t = await super.getUpdateComplete();
    return await this.autofocusReady, t;
  }
  connectedCallback() {
    super.connectedCallback(), this.autofocus && (this.autofocusReady = new Promise(async (t) => {
      await c(), await c(), t();
    }), this.updateComplete.then(() => {
      this.manageAutoFocus();
    }));
  }
}
u([l({ type: Boolean, reflect: !0 })], d.prototype, "disabled", 2), u([l({ type: Boolean })], d.prototype, "autofocus", 2), u([l({ type: Number })], d.prototype, "tabIndex", 1);
export {
  d as F,
  m as a
};
//# sourceMappingURL=focusable-2cSgEeBs.js.map
